import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TSmsStore,
	TSmsListRequest,
	TSmsListResponsePayload,
	TSmsTypesResponsePayload,
	TSmsSendRequest,
} from './types';

// ==========================================:
export const initialState: TSmsStore = {
	smsList: null,
	smsListLoading: false,
	smsTypes: [],
	smsTypesLoading: false,
	smsSendLoading: false,
	smsSendSuccess: false,
};

// ==========================================:
const sms = createSlice({
	name: '@@sms',
	initialState,
	reducers: {
		getSmsListRequest: (state: TSmsStore, _action: PayloadAction<TSmsListRequest>) => {
			state.smsListLoading = true;
		},
		getSmsListSuccess: (state: TSmsStore, action: PayloadAction<TSmsListResponsePayload>) => {
			state.smsList = action.payload;
			state.smsListLoading = false;
		},
		getSmsListFailure: (state: TSmsStore) => {
			state.smsListLoading = false;
		},
		getSmsTypesRequest: (state: TSmsStore) => {
			state.smsTypesLoading = true;
		},
		getSmsTypesSuccess: (state: TSmsStore, action: PayloadAction<TSmsTypesResponsePayload>) => {
			state.smsTypes = action.payload;
			state.smsTypesLoading = false;
		},
		getSmsTypesFailure: (state: TSmsStore) => {
			state.smsTypesLoading = false;
		},
		sendSmsRequest: (state: TSmsStore, _action: PayloadAction<TSmsSendRequest>) => {
			state.smsSendLoading = true;
			state.smsSendSuccess = false;
		},
		sendSmsSuccess: (state: TSmsStore) => {
			state.smsSendLoading = false;
			state.smsSendSuccess = true;
		},
		sendSmsFailure: (state: TSmsStore) => {
			state.smsSendLoading = false;
			state.smsSendSuccess = false;
		},
		smsInitState: () => initialState,
	},
});

export default sms.reducer;
export const {
	getSmsListRequest,
	getSmsListSuccess,
	getSmsListFailure,
	getSmsTypesRequest,
	getSmsTypesSuccess,
	getSmsTypesFailure,
	sendSmsRequest,
	sendSmsSuccess,
	sendSmsFailure,
	smsInitState,
} = sms.actions;
